import { useAppDispatch } from 'app/store';
import { TenantPage } from 'components/common';
import { loadingActions } from 'features';
import { ISAPSettings } from 'interfaces';
import { Tab, Tabs } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sapSettingsService } from 'services/api/SapSettingsService';
import LMToSAPQueueGrid from './LMToSAPQueueGrid';
import SAPSettingsForm from './SAPSettingsForm';

export const SAPSettings = () => {
  const { t } = useTranslation();
  const translationPrefix = 'entities.sap-settings';

  const [sapSettings, setSapSettings] = useState<ISAPSettings>();
  const [tabValue, setTabValue] = useState(0);

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const updateSettings = async (values) => {
    dispatch(loadingActions.startLoading());
    sapSettingsService.update(1, values).then(() => {
      enqueueSnackbar('Impostazioni salvate con successo', { variant: 'success' });
    });
    dispatch(loadingActions.stopLoading());
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    sapSettingsService.get(1).then(setSapSettings);
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary">
        <Tab label={t(`${translationPrefix}.tab_settings`)} value={0} />
        <Tab label={t(`${translationPrefix}.tab_queue`)} value={1} />
      </Tabs>
      {tabValue === 0 && <SAPSettingsForm settings={sapSettings} onSubmit={updateSettings} />}
      {tabValue === 1 && <LMToSAPQueueGrid />}
    </TenantPage>
  );
};

export default SAPSettings;
